<!-- src/views/Home-Index.vue -->
<template>
  <div >
    <!-- 标题 -->
    <el-card>
      <template #header>
        <h1>联业工具合集</h1>
      </template>
      <!-- 说明 -->
      <p></p>
      <!-- 列表容器 -->
      <el-row :gutter="20">
        <el-col :span="8" v-for="item in productList" :key="item.id">
          <el-card>
            <el-link :href="item.url" target="_blank">
              <div>{{ item.name }}</div>
            </el-link>
          </el-card>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script setup>
import { ref } from 'vue';

// 定义商品列表数据
const productList = ref([
  { id: 1, name: '吊牌生成器', url: '/hangtag' },
  { id: 2, name: '图片合成视频', url: '/img2video' },
  { id: 3, name: '建设中', url: '#' }
]);
</script>

<style scoped>
h1 {
  color: #333;
}

p {
  color: #666;
}
</style>